import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'deviceStatusPipe' })
export class DeviceStatusPipe implements PipeTransform {
    transform(value: string): string {
        if (value === 'inactive') {
            return 'STATUS_INACTIVE';
        }
        if (value === 'active') {
            return 'STATUS_AVAILABLE';
        }
        if (value === 'entered-in-error') {
            return 'STATUS_ERROR';
        }
        return 'STATUS_UNKNOWN';
    }
}
